/* eslint-disable react-hooks/exhaustive-deps */
import "./MembershipScreen.css";
import rightArrow from "../../assets/images/membership-card-button-icon.svg";
import appIcon from "../../assets/images/header-app-icon.svg";
import rightOrangeIcon from "../../assets/images/dashboard-right-orenge.svg";
import infoIcon from "../../assets/images/dashboard-info-icon.svg";
import activeTagIcon from "../../assets/images/membership-active-tag.svg";
import paymentHistoryIcon from "../../assets/images/payment-history-icon.svg";
import { useNavigate } from "react-router-dom";
import ROUTE_PATHS from "utils/routePaths";
import { MEMBERSHIP_TYPE, PROFILE_STATUS } from "utils/constants";
import { getMembershipCardImage } from "utils/utils";
import { useEffect, useState } from "react";
import MembershipInviteOnlyDialog from "components/elements/MembershipInviteOnlyDialog";
import { useStorage } from "services/StorageProvider";
import CreditPlanDialog from "components/elements/CreditPlanDialog";
import { STORAGE_KEY } from "utils/strings";

const MembershipScreen = () => {
  const navigate = useNavigate();
  const {
    membershipListData,
    creditPlanListData,
    userProfileData,
    refreshUserProfile,
    refreshAppData,
  } = useStorage();
  const [showInviteOnlyDialog, setShowInviteOnlyDialog] =
    useState<boolean>(false);
  const [showCreditPlanDialog, setShowCreditPlanDialog] =
    useState<boolean>(false);
  const [selectedCreditPlan, setSelectedCreditPlan] = useState<any>(null);
  const [isActiveMember, setIsActiveMember] = useState<boolean>(false);

  useEffect(() => {
    refreshUserProfile();
    refreshAppData();
    setIsActiveMember(
      userProfileData?.credit?.status === PROFILE_STATUS.MEMBER,
    );
  }, []);

  const approvedMembership = membershipListData?.data?.content?.find(
    (membership: any) =>
      membership.id === userProfileData?.credit?.approved_membership,
  );

  const filteredMembershipList = !isActiveMember
    ? membershipListData?.data?.content?.filter(
        (membership: any) =>
          membership.id !== userProfileData?.credit?.approved_membership,
      )
    : membershipListData?.data?.content;

  const handleURMembershipCardClick = () => {
    navigate(ROUTE_PATHS.WSM_UR_MEMBERSHIP_PLAN_DETAIL);
  };

  const handleMembershipCardClick = (data: any) => {
    if (
      data?.membership_level === 3 &&
      data?.id !== userProfileData?.credit?.approved_membership
    ) {
      setShowInviteOnlyDialog(true);
    } else {
      localStorage.setItem(
        STORAGE_KEY.SELECTED_MEMBERSHIP_DATA,
        JSON.stringify(data),
      );
      navigate(ROUTE_PATHS.WSM_MEMBERSHIP_PLAN_DETAIL);
    }
  };

  const handleCreditPlanCardClick = (data: any) => {
    setSelectedCreditPlan(data);
    setShowCreditPlanDialog(true);
  };

  // const handleFullDayPassClick = (data: any) => {
  //   localStorage.setItem(STORAGE_KEY.SELECTED_FULL_DAY_PASS_DATA, JSON.stringify(data));
  //   navigate(ROUTE_PATHS.WSM_MEMBERSHIP_ONE_DAY_PASS_DETAIL);
  // };

  const handlePaymentHistoryClick = () => {
    navigate(ROUTE_PATHS.WSM_PAYMENT_HISTORY);
  };

  return (
    <div className="wms-mobile-container">
      <header className="membership-screen-header-header-bar">
        <div className="membership-screen-header-left-container">
          <img src={appIcon} alt="logo" />
        </div>
        <div className="membership-screen-header-divider"></div>
        <div className="membership-screen-header-right-container">
          <span>Memberships</span>
          <img
            src={paymentHistoryIcon}
            alt="left-button"
            onClick={handlePaymentHistoryClick}
          />
        </div>
      </header>

      {userProfileData?.credit?.is_active && (
        <div className="membership-screen-membership-container ur-wallet">
          <div className="header-title">
            UR <span style={{ color: "#C2B58C" }}>Wallet</span>
          </div>
          <div className="divider"></div>
          <div
            className={`membership-screen-my-membership-container ${userProfileData?.credit?.membership?.membership_type}`}
            onClick={handleURMembershipCardClick}
          >
            <div className="sub-container">
              <span
                style={{
                  color: `${userProfileData?.credit?.membership?.membership_level === 3 ? "black" : "white"}`,
                }}
              >
                Everything Ur Wallet Card gets you{" "}
              </span>
              <div className="right-container">
                <span>
                  {userProfileData?.credit?.credit_balance > 1
                    ? "Credits"
                    : "Credit"}{" "}
                  : {userProfileData?.credit?.credit_balance}
                </span>{" "}
                <button>
                  <img src={rightArrow} alt="right-arrow" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {approvedMembership && !userProfileData?.credit?.membership && (
        <div className="membership-screen-container">
          <div className="membership-screen-membership-container">
            <div className="header-title">{approvedMembership?.title}</div>
            <div className="divider"></div>
            <div className="membership-screen-approved-membership-container">
              <div className="membership-screen-approved-membership-header-banner">
                <img src={infoIcon} alt="info-icon" />
                <span>
                  <span style={{ color: "#CDD7D6" }}>
                    Membership Approved — Just Activate It!
                  </span>{" "}
                  <span style={{ color: "#C2B58C" }}>
                    Complete your payment to
                  </span>{" "}
                  unlock your Foundry benefits.
                </span>
              </div>
              <div className="membership-screen-approved-membership-sub-container">
                <div
                  className="image-text-container"
                  onClick={() => handleMembershipCardClick(approvedMembership)}
                >
                  <img
                    className="card-image"
                    src={getMembershipCardImage(
                      approvedMembership?.membership_type,
                    )}
                    alt="membership-card"
                  />
                </div>
                <div className="right-container">
                  <div className="detail-container">
                    {approvedMembership?.title}
                  </div>
                  <button
                    onClick={() =>
                      handleMembershipCardClick(approvedMembership)
                    }
                  >
                    Pay Now
                    <img src={rightArrow} alt="right-arrow" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="membership-screen-container">
        <div className="membership-screen-membership-container">
          <div className="header-title">
            Workspace <span style={{ color: "#C2B58C" }}>CARDS</span>
          </div>
          <div className="divider"></div>
          {filteredMembershipList?.map((membership: any, index: number) => (
            <div>
              <div
                key={index}
                className={`membership-screen-card-container ${
                  userProfileData?.credit?.membership?.membership_type ===
                  membership?.membership_type
                    ? "active-container"
                    : "non-active-container"
                }`}
              >
                <div
                  className="image-text-container"
                  onClick={() => handleMembershipCardClick(membership)}
                >
                  <img
                    className={`membership-card-image active-shadow`}
                    src={getMembershipCardImage(membership?.membership_type)}
                    alt="membership-card"
                  />
                </div>
                <div className="right-container">
                  <div
                    className="button-container"
                    style={{
                      backgroundImage: `url(${
                        userProfileData?.credit?.membership?.membership_type ===
                          membership?.membership_type && activeTagIcon
                      })`,
                    }}
                  >
                    <button
                      onClick={() => handleMembershipCardClick(membership)}
                    >
                      {
                        MEMBERSHIP_TYPE.find(
                          (type) => type.value === membership?.membership_type,
                        )?.name
                      }
                      <img src={rightArrow} alt="right-arrow" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div style={{ height: "50px" }}></div>
        </div>

        {creditPlanListData?.data?.content?.length > 0 && isActiveMember && (
          <div className="membership-screen-credit-container">
            <div className="header">
              Top up <span style={{ color: "#C2B58C" }}>CREDITS</span>
            </div>
            <div className="divider"></div>
            <div className="membership-screen-credit-sub-container">
              {creditPlanListData?.data?.content?.map(
                (creditPlan: any, index: number) => {
                  return (
                    <div
                      key={index}
                      className="membership-screen-credit-container-cell"
                      onClick={() => handleCreditPlanCardClick(creditPlan)}
                    >
                      <div className="header-container">
                        <span>{creditPlan?.title}</span>
                      </div>
                      <div className="credit-number-container">
                        {creditPlan?.total_credits}{" "}
                        <span>
                          {creditPlan?.total_credits > 1 ? "Credits" : "Credit"}
                        </span>
                      </div>
                      <div className="credit-price-container">
                        ₹ {creditPlan?.credit_price?.toLocaleString("en-US")}
                      </div>
                      <div className="button-container">
                        <img src={rightOrangeIcon} alt="right-button" />
                      </div>
                    </div>
                  );
                },
              )}
            </div>
          </div>
        )}

        {/* {!passesListError &&
          passesListData?.data?.content?.map((passData: any, index: number) => (
            <div
              className="membership-screen-one-day-pass-container"
              style={{
                backgroundImage: `url(${cardSecondImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="membership-screen-one-day-pass-sub-container">
                <div className="title">{passData?.title}</div>
                <div className="sub-title">
                  {passData?.pass_days} Full Day Access
                </div>
                <div className="btn-container">
                  <button onClick={() => handleFullDayPassClick(passData)}>
                    Explore
                  </button>
                </div>
              </div>
            </div>
          ))} */}
      </div>
      <MembershipInviteOnlyDialog
        profileStatus={userProfileData?.credit?.status}
        open={showInviteOnlyDialog}
        onClose={() => setShowInviteOnlyDialog(false)}
      />
      <CreditPlanDialog
        planData={selectedCreditPlan}
        open={showCreditPlanDialog}
        onClose={() => setShowCreditPlanDialog(false)}
      />
    </div>
  );
};

export default MembershipScreen;
